export const RESOURCE_PROJECT_ID_PRFX = 'project-';
